import { StandardSkillJSON, StandardSkill } from '../types';

export default class StandardSkillsSerializer {
  static toObject(skill: StandardSkillJSON): StandardSkill {
    return {
      resourceId: skill.resource_id,
      name: {
        en: skill.name_en,
        de: skill.name_de,
      },
      skillCategory: skill.skill_category,
    };
  }

  static toObjects(payload: StandardSkillJSON[]): StandardSkill[] {
    return payload.map((skill) =>
      StandardSkillsSerializer.toObject(skill)
    );
  }
}
